import { render, staticRenderFns } from "./bankAsideList.vue?vue&type=template&id=63c3f3e1"
import script from "./bankAsideList.vue?vue&type=script&lang=js"
export * from "./bankAsideList.vue?vue&type=script&lang=js"
import style0 from "./bankAsideList.vue?vue&type=style&index=0&id=63c3f3e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports